<template>
  <span>
    <el-cascader ref="cascader" v-model="selectedData" :disabled="disabled" class="allcascader" :size="size" :popper-class="'cascader-box '+popperClass" :clearable="clearable" :collapse-tags="collapseTags" :multiple-limit="multipleLimit" :placeholder="placeholder" :filterable="filterable" :options="select_optionsList" :filter-method="handleFilter" :props="{ expandTrigger: 'hover',multiple:true,label:props.label,value:props.value,children:props.children,disabled:props.disabled }" @change="handleChange" @visible-change="handleVisible">
      <template slot-scope="{ data }">
        <div style="display:flex;justify-content: space-between;">
          <div>{{ data[props.label] }}</div>

          <div style="font-size:10px;color:#999;margin-left:10px">
            <!-- <span>{{ data['parentChannelCode'] }} </span> -->
            <span style="margin-left:10px">{{ data[props.value] }} </span>
          </div>
        </div>

      </template>
    </el-cascader>

    <div class="m-extra" :class="popperClass+'checked'">
      <div class="wrap">
        <el-checkbox v-model="checked" @change="allchecked">全选</el-checkbox>
      </div>
    </div>

    <!-- 示例  popper-class 为必填项 并且保证值唯一  必须保证数据里的value没有空值
      <multiple-cascader v-model="value" :optionsList="options" clearable collapse-tags placeholder="请选择" filterable :props="{'label':'label','value':'value','children':'children'}"
        popper-class="popperClass1" style="float:left" @change="valuechange" @visible-change="handleVisible"></multiple-cascader>
     -->
  </span>

</template>

<script>
export default {
  props: {
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false
    },

    // 输入框大小
    size: {
      type: String,
      default: ''
    },

    // 是否可清空
    clearable: {
      type: Boolean,
      default: false
    },

    // 多选时是否将选中值按文字的形式展示
    collapseTags: {
      type: Boolean,
      default: false
    },

    // 多选时用户最多可以选择的项目数，为 0 则不限制
    multipleLimit: {
      type: Number,
      default: 0
    },

    // 占位符
    placeholder: {
      type: String,
      default: '请选择'
    },
    // 自定义浮层类名
    popperClass: {
      type: String,
      default: ''
    },

    // 是否可搜索
    filterable: {
      type: Boolean,
      default: false
    },

    // 待选项
    optionsList: {
      type: Array,
      required: true
      // default: () => []
    },

    // 选项字段
    props: {
      type: Object,
      default: () => {
        'label'
        'value'
        'children'
        'disabled'
      }
    },

    value: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      default_optionsList: [], // 默认所有选项
      select_optionsList: [], // 待选项
      selectedValues: [], // 已选
      selectStates: 0, // 是否全选过
      allData: [],
      checked: false,
      datalist: [],
      keyword: ''
    }
  },

  computed: {
    // 已选值
    selectedData: {
      get() {
        this.selectedValues = [...this.value]
        return [...this.value]
      },
      set(val) {
        this.$emit('input', [...val])
      }
    }
  },

  watch: {
    optionsList(val) {
      this.default_optionsList = val
      this.init()
    }
  },

  mounted() {
    this.default_optionsList = this.optionsList

    this.init()
  },

  methods: {
    // 初始化数据
    init() {
      this.select_optionsList = JSON.parse(JSON.stringify(this.default_optionsList))
      this.allcheckedClass()
      // 手动给组件设置值时 设置全选
      // this.handleChange(this.selectedData)
      const totalCount = this.allnum(this.select_optionsList)
      if (totalCount > 0 && this.selectedData.length == totalCount) {
        this.checked = true
      } else {
        this.checked = false
      }
    },
    // 添加全选按钮
    allcheckedClass() {
      var classA = document.getElementsByClassName(this.popperClass)[0]
      if (classA.firstChild.className != 'wrap') {
        var classC = document.getElementsByClassName(this.popperClass + 'checked')[0].firstChild
        var classB = classA.firstChild
        classA.insertBefore(classC, classB)
      }
    },
    // 全选按钮点击
    allchecked(e) {
      if (this.selectStates == 1) {
        var arr1 = JSON.parse(JSON.stringify(this.selectedData))
        this.selectedData.forEach((i, iindex) => {
          this.datalist.forEach((s, sindex) => {
            if (String(i) == String(s)) {
              delete arr1[iindex]
            }
          })
        })
        var arr = []
        arr1.forEach(n => {
          if (n && n != null && n != '') {
            arr.push(n)
          }
        })
        if (e) {
          this.selectedData = arr.concat(this.datalist)
          this.$nextTick(() => {
            this.$emit('change', this.selectedData)
          })
        } else {
          this.$nextTick(() => {
            this.selectedData = arr
            this.$emit('change', this.selectedData)
          })
        }
      } else {
        this.checked = e
        this.datalist = []
        if (e) {
          var values = this.handleSelectAll()
          this.$nextTick(() => {
            this.selectedData = values
            this.$emit('change', values)
          })
        } else {
          this.selectedData = this.datalist
          this.$nextTick(() => {
            this.$emit('change', this.selectedData)
          })
        }
      }
    },
    // 获取全部的总数
    allnum(options) {
      let count = 0

      const countLeafNodes = (nodes) => {
        nodes.forEach(node => {
          if (node[this.props.children] && node[this.props.children].length > 0) {
            countLeafNodes(node[this.props.children])
          } else {
            count++
          }
        })
      }

      countLeafNodes(options)
      return count
    },
    // 监听下拉框
    handleVisible(val) {
      this.selectStates = 0
      // this.checked = false;
      this.$emit('visible-change', val)
      if (val) {
        this.init()
      }
    },

    // 监听select值变化
    handleChange(value) {
      this.$emit('change', value)
      const totalCount = this.allnum(this.select_optionsList)
      if (totalCount > 0 && value.length == totalCount) {
        this.checked = true
      } else {
        this.checked = false
      }
    },
    // 全选全部数据值
    handleSelectAll() {
      this.allData = []
      this.getAllLeafPaths(this.select_optionsList, [])
      return this.allData
    },

    // 递归获取所有叶子节点的路径
    getAllLeafPaths(nodes, currentPath) {
      nodes.forEach(node => {
        const newPath = [...currentPath, String(node[this.props.value])]

        // 如果有子节点，继续递归
        if (node[this.props.children] && node[this.props.children].length > 0) {
          this.getAllLeafPaths(node[this.props.children], newPath)
        } else {
          // 叶子节点，添加到结果中
          this.allData.push(newPath)
        }
      })
    },

    // 筛选
    handleFilter(node, keyword) {
      this.checked = false
      this.selectStates = 1
      if (this.keyword != keyword) {
        this.keyword = keyword
        this.datalist = []
      }
      if (node.label.toLowerCase().indexOf(keyword.toLowerCase()) > -1 || node.value.toLowerCase().indexOf(keyword.toLowerCase()) > -1) {
        this.datalist.push(node.path)
        return true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.m-extra {
  display: none;
}
.wrap {
  padding: 6px 20px 5px;
  border-bottom: 1px solid #dedede;
}
.allcascader {
  ::v-deep .el-cascader__tags {
    .el-tag {
      max-width: 58%;
    }
    .el-cascader__search-input {
      margin: 2px 0 2px 5px;
      min-width: 3%;
    }
  }
}
</style>
